// @ts-nocheck
import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../services/api';

export default function ProjectDetail() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/projects/${id}/summary`)
            .then((res) => setData(res.data.data))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) return <div className="text-center py-5"><div className="spinner-border text-success" /></div>;
    if (!data) return <div className="alert alert-warning">Project not found</div>;

    const { project, inventory, sales } = data;

    return (
        <div>
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/projects">Projects</Link></li>
                    <li className="breadcrumb-item active">{project.name}</li>
                </ol>
            </nav>
            <h4 className="mb-1">{project.name}</h4>
            <p className="text-muted">{project.code} · {project.location} · <span className="text-capitalize">{project.status?.replace('_', ' ')}</span></p>

            <div className="row g-3 mb-4">
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Total Units</div>
                        <div className="fs-4 fw-bold">{inventory.total}</div>
                    </div></div>
                </div>
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Available</div>
                        <div className="fs-4 fw-bold text-success">{inventory.available}</div>
                    </div></div>
                </div>
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Sale Value</div>
                        <div className="fs-5 fw-bold">৳ {sales.total_sale_value?.toLocaleString()}</div>
                    </div></div>
                </div>
                <div className="col-md-3">
                    <div className="card stat-card"><div className="card-body">
                        <div className="text-muted small">Collected</div>
                        <div className="fs-5 fw-bold text-success">৳ {sales.total_collected?.toLocaleString()}</div>
                    </div></div>
                </div>
            </div>

            <div className="card table-card">
                <div className="card-header bg-white d-flex justify-content-between">
                    <span className="fw-semibold">Inventory Units</span>
                    <Link to={`/units?project_id=${id}`} className="btn btn-sm btn-outline-primary">View All</Link>
                </div>
                <div className="card-body">
                    <p className="mb-0">Booked: {inventory.booked} · Sold: {inventory.sold} · Outstanding: ৳ {sales.outstanding?.toLocaleString()}</p>
                </div>
            </div>
        </div>
    );
}
